<template>
  <div>
    <a-spin size="large" :spinning="cancerVis" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        row-id="id"
        size="small"
        :row-config="{ height: 35, isCurrent: true, isHover: true }"
        ref="xTable"
        :data="tableData_detable"
        class="my-sort"
        align="center"
        header-align="center"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="genename" title="Gene name" type="html">
          <template #default="{ row }">
            <div style="text-align: center; font-weight: bolder; color: blue">
              <span
                @click="goQuickGene(row.genename)"
                onmouseover="this.style.cursor='pointer'"
              >
                {{ row.genename }}
              </span>
            </div>
          </template>
        </vxe-column>
        <vxe-column
          field="log2fc"
          title="Log2FC"
          type="html"
          sortable
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'The expression data are first log2(TPM+1) transformed for differential analysis and the log2FC is defined as median(Tumor) - median(Normal)',
          }"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
          <template #default="{ row }">
            <a-tag
              v-if="row.log2fc >= 0"
              color="#AA4643"
              onmouseover="this.style.cursor='pointer'"
              @click="showPDF(row.ensgId, row.pvalue, row.cancer, row.genename)"
              >{{ row.log2fc }}</a-tag
            >
            <a-tag
              v-else
              color="#4572a7"
              onmouseover="this.style.cursor='pointer'"
              @click="showPDF(row.ensgId, row.pvalue, row.cancer, row.genename)"
              >{{ row.log2fc }}</a-tag
            >
          </template>
        </vxe-column>
        <vxe-column
          field="pvalue"
          title="DE p-value"
          sortable
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'The method for differential analysis is one-way ANOVA, using disease state (Tumor or Normal) as variable for calculating differential expression',
          }"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <!-- :title="'OS pvalue for ' + this.value" -->
        <vxe-column
          field="survival"
          title="OS p-value"
          sortable
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'Overall survival p-value calculated with splitting the high-expression and low-expression cohorts by median',
          }"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
          <template #default="{ row }">
            <a-tag
              v-if="row.survival.length >= 0"
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="
                showPDF2(row.ensgId, row.pvalue, row.cancer, row.genename)
              "
              >{{ row.survival }}</a-tag
            >
          </template>
        </vxe-column>
        <vxe-column
          field="corR"
          title="CNV (R)"
          type="html"
          sortable
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'Correlation between Copy number variation (CNV) and mRNA expression across pan-cancer',
          }"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
          <template #default="{ row }">
            <a-tag
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="
                showPDF3CNV(row.ensgId, row.pvalue, row.cancer, row.genename)
              "
              >{{ row.corR }}</a-tag
            >
          </template>
        </vxe-column>
        <vxe-column
          field="eQTLnum"
          title="Cis-eQTLs"
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              ' Expression quantitative trait loci (eQTLs) are regions of the genome containing DNA sequence variants that influence the expression level of genes. Here we provide a comprehensively cis-eQTLs of affectting gene expression',
          }"
        >
          <template #default="{ row }">
            <a-tag
              v-if="row.eQTLnum > 0"
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="showQTL(row.ensgId, row.pvalue, row.cancer, row.genename)"
              >{{ row.eQTLnum }}</a-tag
            >
          </template>
        </vxe-column>
        <vxe-column
          field="simiGene"
          title="Similar genes"
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'This function identifies a list of genes with similar expression pattern with an input gene and selected cancer type',
          }"
          show-overflow
        >
          <template #default="{ row }">
            <a-tag
              v-if="row.survival.length >= 0"
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="
                showPDF3(row.ensgId, row.pvalue, row.cancer, row.genename)
              "
              ><a-icon type="dot-chart"
            /></a-tag> </template
        ></vxe-column>
        <!-- <vxe-column
          field="vHallmark"
          title="Phenotypes"
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message: 'Cancer-associated phenotypes',
          }"
        >
          <template #default="{ row }">
            <a-tag
              v-if="row.survival.length >= 0"
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="
                showPDF3(row.ensgId, row.pvalue, row.cancer, row.genename)
              "
              >Explore</a-tag
            >
          </template></vxe-column
        > -->
        <!-- :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'The results of Gene Set Enrichment Analysis (GSEA) using the Hallmark gene sets, comparing the expression profiles between perturbed cells and non-targeting cells',
          }" -->
        <vxe-column field="gHallmark" title="GSEA(Perturb-Seq)" type="html">
          <template #default="{ row }">
            <a-tag
              v-if="row.survival.length >= 0"
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="showgsea(row.gHallmark)"
              >View</a-tag
            >
          </template></vxe-column
        >
        <!-- 等待更新 -->
        <!-- <vxe-column field="clusterID" title="GSEA(bulkPerturb-seq)" type="html">
          <template #default="{ row }">
            <div
              v-if="
                row.clusterID !== null &&
                row.clusterID !== '' &&
                row.clusterID !== '-'
              "
              style="text-align: center"
            >
              <div
                v-for="(index, element) in row.clusterID.split(',')"
                :key="index"
                :value="element"
              >
                <a-tag
                  color="#4572a7"
                  style="margin-bottom: 2px"
                  @click="goTOpc(index)"
                >
                  {{ index }}</a-tag
                >
              </div>
            </div>
          </template>
        </vxe-column> -->
        <vxe-column field="genetype" title="Gene types" type="html">
          <template #default="{ row }">
            <div style="text-align: center" v-if="row.genetype != null">
              <div
                v-for="(index, element) in row.genetype.split(',')"
                :key="index"
                :value="element"
              >
                <a-tag
                  v-if="index == 'RBP'"
                  color="pink"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'TF'"
                  color="red"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'Metabolism'"
                  color="orange"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag>
                <a-tag
                  v-if="index == 'Essential'"
                  color="green"
                  style="margin-bottom: 2px"
                >
                  Essential gene
                </a-tag>
                <!-- <a-tag
                  v-if="index == 'E3'"
                  color="cyan"
                  style="margin-bottom: 2px"
                >
                  {{ index }}
                </a-tag> -->
              </div>
            </div>
          </template>
        </vxe-column>
        <template #empty>
          <span style="color: grey"></span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[20, 50, 75, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
      <!-- 差异分析 -->
      <a-modal
        :visible="this.modal"
        :maskClosable="false"
        :closable="false"
        :destroyOnClose="true"
        style="margin-top: 300px"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">TCGA based on sample types</div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <TCGAboxplotModal
          v-bind:ensgId="this.ensgId"
          v-bind:selectCa="this.selectCancer"
          v-bind:pvalue="this.pvalue"
          v-bind:genename="this.genename"
        />
      </a-modal>
      <!-- 生存分析 -->
      <a-modal
        :visible="this.survialModal"
        :maskClosable="false"
        :destroyOnClose="true"
        :keyboard="false"
        :closable="false"
        style="margin-top: 300px"
        :width="880"
        @ok="handleOk2"
        @cancel="handleCancel2"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">Survival plots</div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <survival
          v-bind:ensgId="this.ensgId"
          v-bind:gene="this.genename"
          v-bind:selectCa="this.selectCancer"
        />
      </a-modal>
      <!-- 相似基因 -->
      <a-modal
        :visible="this.simiModal"
        :maskClosable="true"
        :destroyOnClose="true"
        :keyboard="true"
        :closable="false"
        style="margin-top: 300px"
        :width="880"
        @ok="handleOk3"
        @cancel="handleCancel3"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">Similar genes detection</div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <simiGene
          v-bind:ensgId="this.ensgId"
          v-bind:gene="this.genename"
          v-bind:selectCa="this.selectCancer"
        />
      </a-modal>
      <!-- 拷贝数变异和转录组 -->
      <a-modal
        :visible="this.cnvModal"
        :maskClosable="true"
        :destroyOnClose="true"
        :keyboard="true"
        :closable="false"
        style="margin-top: 300px"
        :width="880"
        @ok="handleOk5"
        @cancel="handleCancel5"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">
          Pan-cancer correlation analysis between Copy number variation (CNV)
          and mRNA expression of
          <span style="color: red; font-size: bolder"
            >{{ this.genename }}
          </span>
        </div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <cnvGene
          v-bind:ensgId="this.ensgId"
          v-bind:gene="this.genename"
          v-bind:selectCa="this.selectCancer"
        />
      </a-modal>
      <!-- 数量性状 -->
      <a-modal
        :visible="this.qtlModal"
        :maskClosable="true"
        :destroyOnClose="true"
        :keyboard="true"
        :closable="false"
        style="margin-top: 300px"
        :width="880"
        @ok="handleOk6"
        @cancel="handleCancel6"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">Cis-eQTLs list</div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <eQTL
          v-bind:ensgId="this.ensgId"
          v-bind:gene="this.genename"
          v-bind:selectCa="this.selectCancer"
        />
      </a-modal>
      <!-- GSEA之 hallmark 分析 -->
      <a-modal
        :visible="this.gseaModal"
        :maskClosable="true"
        :destroyOnClose="true"
        :keyboard="true"
        :closable="true"
        :width="1000"
        @ok="handleOk4"
        @cancel="handleCancel4"
        :footer="null"
        :cancel-button-props="{ props: { disabled: true } }"
      >
        <div slot="title">GSEA analysis of Hallmark</div>
        <div slot="cancelText">
          <a-icon type="cloud-download" />
        </div>
        <a-tabs>
          <a-tab-pane v-for="(tab, index) in tabs" :key="index">
            <span slot="tab">{{ tab.dataset }}</span>
            <hallmark :gene="tab.genename" :dataset="tab.dataset" />
          </a-tab-pane>
        </a-tabs>
      </a-modal>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
import TCGAboxplotModal from "./TCGAboxplotModal.vue";
import survival from "./survival.vue";
import simiGene from "./SimilarGenes.vue";
import cnvGene from "./cnvAndmRNA.vue";
import eQTL from "./QTL.vue";
import hallmark from "./hallmark.vue";

export default {
  components: { TCGAboxplotModal, survival, simiGene, hallmark, cnvGene, eQTL },
  props: ["value"],
  data() {
    return {
      cancerVis: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      // boxplot
      modal: false,
      ensgId: "",
      genename: "",
      selectCancer: "",
      pvalue: "",
      // survival
      survialModal: false,
      //simi gene
      simiModal: false,
      //CNV
      cnvModal: false,
      //eQTL:
      qtlModal: false,
      // gsea 点击的时候要重新给这个tabs赋值
      gseaModal: false,
      tabs: [],
      // bulk gsea 类似于 gsea
      bulkGseaModal: false,
      bulkTabs: false,
      // 网站基本地址
      webiste: "http://research.gzsys.org.cn/perturbdb",
      //加载
      loading: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: true,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  watch: {
    value() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      this.filterName_detable = "";
      this.cancerVis = true;
      this.loading = true;
      axios
        .get("http://research.gzsys.org.cn/perturbdb/API/geneCancer/genes.php")
        .then((response) => {
          this.getdata_detable = response.data.filter(
            (item) => item.cancer === this.value
          );
          this.findList_detable(this.getdata_detable);
          this.loading = false;
        });
      this.cancerVis = false;
    },
  },
  created() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/geneCancer/genes.php")
      .then((response) => {
        this.getdata_detable = response.data.filter(
          (item) => item.cancer === "BRCA"
        );
        this.findList_detable(this.getdata_detable);
        this.cancerVis = false;
      });
  },

  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/API/geneCancer/genes.php"
            )
            .then((response) => {
              this.getdata_detable = response.data.filter(
                (item) => item.cancer === this.value
              );
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.loading = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    // boxplot 弹窗
    showPDF(value1, value2, value3, value4) {
      this.modal = true;
      this.ensgId = value1;
      // this.pvalue = Number.parseFloat(value2).toPrecision(4);
      this.pvalue = value2;
      this.selectCancer = value3.split("-")[0];
      this.genename = value4;
    },
    handleOk() {
      this.modal = false;
    },
    // 生存弹窗
    showPDF2(value1, value2, value3, value4) {
      this.survialModal = true;
      this.ensgId = value1;
      // this.pvalue = Number.parseFloat(value2).toPrecision(4);
      this.pvalue = value2;
      this.selectCancer = value3.split("-")[0];
      this.genename = value4;
    },
    handleOk2() {
      this.survialModal = false;
    },
    // 相似基因弹窗
    showPDF3(value1, value2, value3, value4) {
      this.simiModal = true;
      this.ensgId = value1;
      // this.pvalue = Number.parseFloat(value2).toPrecision(4);
      this.pvalue = value2;
      this.selectCancer = value3.split("-")[0];
      this.genename = value4;
    },
    handleOk3() {
      this.simiModal = false;
    },
    // gsea分析
    showgsea(valueGSEA) {
      this.tabs = JSON.parse(valueGSEA);
      this.gseaModal = true;
      // console.log(this.tabs);
    },
    handleOk4() {
      this.gseaModal = false;
    },
    handleCancel4() {
      this.gseaModal = false;
    },
    handleOk5() {
      this.cnvModal = false;
    },
    showQTL(value1, value2, value3, value4) {
      this.qtlModal = true;
      this.ensgId = value1;
      // this.pvalue = Number.parseFloat(value2).toPrecision(4);
      this.pvalue = value2;
      this.selectCancer = value3.split("-")[0];
      this.genename = value4;
    },
    handleOk6() {
      this.qtlModal = false;
    },
    showPDF3CNV(value1, value2, value3, value4) {
      this.cnvModal = true;
      this.ensgId = value1;
      // this.pvalue = Number.parseFloat(value2).toPrecision(4);
      this.pvalue = value2;
      this.selectCancer = value3.split("-")[0];
      this.genename = value4;
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "Perturbed_gene_in_TCGA-" + this.value,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            this.filterName_detable +
            "_related_perturbed_gene_in_TCGA-" +
            this.value,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goQuickGene(value) {
      let routeData = this.$router.resolve({
        name: "quickSearch",
        query: { gene: value },
      });
      window.open(routeData.href, "_blank");
      this.value = "";
    },
    goQuickSearch(value) {
      let href = this.webiste + "/#/quickSearch?gene=" + value;
      window.open(href, "_blank");
    },
    goTOpc(value) {
      let href = this.webiste + "/#/pcDetails?pcID=" + value;
      window.open(href, "_blank");
    },
    goDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    goDatasetBulk(value, value2) {
      let href =
        "http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "genename",
          "ensemble",
          "genetype",
          "datasetID",
          "clusters",
          "localization",
        ];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        // 必须装回来
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
